import React, { useRef } from 'react'
import BootstrapTable from "react-bootstrap-table-next"
import cellEditFactory from 'react-bootstrap-table2-editor';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { CSVExport } from 'react-bootstrap-table2-toolkit';
import commaNumber from 'comma-number'

const { ExportCSVButton } = CSVExport;

const expandRow = {
    nonExpandable: [1, 3],
    showExpandColumn: true,
    renderer: row => (
        <table>
            <thead>
                <tr>
                    <th>Product Name</th>
                    <th>Qty</th>
                    <th>Cost</th>
                    <th>Total Cost</th>
                    <th>30 day sales</th>
                    <th>60 day sales</th>
                </tr>
            </thead>
            <tbody>
                {row.subProducts.map((variant) => {
                    return <tr>
                        <td>{variant.productName}</td>
                        <td>{variant.qtyByDate[variant.qtyByDate.length - 1][0][1].toFixed(0)}</td>
                        <td>{variant.productCost}</td>
                        <td>£{commaNumber((variant.productCost * variant.qtyByDate[variant.qtyByDate.length - 1][0][1]).toFixed(2))}</td>
                        <td>{variant.thirtyDaySales}</td>
                        <td>{variant.sixtyDaySales}</td>
                    </tr>
                })}
                <tr>
                    <td><strong>Total</strong></td>
                    <td><strong>{row.subProducts.reduce((acc, x) => acc += x.qtyByDate[x.qtyByDate.length - 1][0][1], 0)}</strong></td>
                    <td></td>
                    <td><strong>£{commaNumber(row.subProducts.reduce((acc, x) => acc += x.qtyByDate[x.qtyByDate.length - 1][0][1] * x.productCost, 0).toFixed(2))}</strong></td>
                    <td><strong>{row.subProducts.reduce((acc, x) => acc += x.thirtyDaySales, 0)}</strong></td>
                    <td><strong>{row.subProducts.reduce((acc, x) => acc += x.sixtyDaySales, 0)}</strong></td>
                </tr>
            </tbody>


        </table>

    )
};


export const StockValueTableView = (props) => {

    const tableRef = useRef(null);
    const columns = [{
        dataField: 'Index',
        text: '#',
        isDummyField: true,
        formatter: (cell, row, idx) => idx + 1 + ((props.currentPage - 1) * 100)
    }, {
        dataField: 'parentId',
        text: 'Parent Id',
        editable: false,
        footer: ''
    },
    {
        dataField: 'id',
        text: 'Product ID',
        formatter: (cell) => <a href={`https://h.merchoid.com/admin5YodaRed5Palpatine2/?page=inventoryEdit&productId=${cell}`}>{cell}</a>,
        editable: false,
        footer: ''
    }, {
        dataField: 'productName',
        text: 'Product Name',
        filter: textFilter(),
        editable: false,
        footer: '',
        formatter: (cell) => cell.replace(/\s*\([^)]*\bsize\b[^)]*\)/gi, "")
    }, {
        dataField: 'productCost',
        text: 'Cost',
        editable: false,
        formatter: (cell) => '£' + cell.toFixed(2),
        footer: ''
    }, {
        dataField: 'supplierName',
        text: 'Supplier Name',
        filter: textFilter(),
        editable: false,
        footer: ''

    }, {
        dataField: 'productBrand',
        text: 'Brand',
        filter: textFilter(),
        editable: false,
        footer: ''
    }, {
        dataField: 'productCategory',
        text: 'Category',
        filter: textFilter(),
        editable: false,
        footer: ''

    }, {
        dataField: 'totalCost',
        text: 'Total Cost',
        editable: false,
        sort: true,
        formatter: (cell) => <div><div>{'£' + commaNumber(cell.toFixed(2))}</div></div>,
        footer: () => '£' + commaNumber((props.products.reduce((acc, item) => acc + item.totalCost, 0)).toFixed(2))


    }, {
        dataField: 'totalQuantity',
        text: 'Total Quantity',
        editable: false,
        formatExtraData: props.filteredTotalQuantity,
        formatter: (cell, row, index, formatExtraData) => <div>
            <div>{commaNumber(cell)}</div>
            <div><strong>{((cell * 100) / formatExtraData).toFixed(2)}</strong>%</div>
        </div>,
        sort: true,
        footer: () => commaNumber((props.products.reduce((acc, item) => acc + item.totalQuantity, 0)).toFixed(0))

    },
    {
        dataField: 'thirtyDaySales',
        text: '30 Day Sales',
        editable: false,
        sort: true,
        formatter: (cell, row) => <div>
            <div>{row.totalThirtyDaySales}</div>
            <div>{row.totalQuantity / row.totalThirtyDaySales * 30 > 0
                ? <strong>{commaNumber(Math.max(1, (row.totalQuantity / row.totalThirtyDaySales * 30).toFixed(0))) + ' days sellthru'}</strong>
                : ''}
            </div>
        </div>

    },
    {
        dataField: 'sixtyDaySales',
        text: '60 Day Sales',
        editable: false,
        sort: true,
        formatter: (cell, row) => <div>
            <div>{row.totalSixtyDaySales}</div>
            <div>{row.totalQuantity / row.totalSixtyDaySales * 15 > 0
                ? <strong>{Math.max(1, (row.totalQuantity / row.totalSixtyDaySales * 30).toFixed(0)) + ' days sellthru'}</strong>
                : ''}
            </div>
        </div>

    },
    {
        dataField: 'runningTotalValue',
        isDummyField: true,
        text: 'Total Value',
        editable: false,
        formatter: (cell, row, rowIndex, formatExtraData) => {
            const data = tableRef.current ? tableRef.current.paginationContext.props.data : props.products
            const indexEnd = (props.currentPage - 1) * 100
            const previousRows = data.slice(0, rowIndex + indexEnd);
            const cumulativeTotal = previousRows.reduce((total, row) => {
                return parseFloat(total) + parseFloat(row.totalCost)
            }, 0);

            const sum = parseFloat(cumulativeTotal) + parseFloat(row.totalCost)
            const pc = (sum / props.filteredTotalCost) * 100
            return <div><div><strong>Acc. </strong>£{commaNumber(sum.toFixed(2))}</div><div><strong>Acc.</strong>{pc.toFixed(2)}%</div></div>
        },


    },
    ]


    // //after filter, recalculate totals for the footer, update filtered state
    // const afterFilter = (newResult) => {
    //     const totalQuantity = newResult.reduce((acc, product) => {
    //         return acc += product.totalQuantity
    //     }, 0)
    //     props.setFilteredTotalQuantity(totalQuantity)
    //     const totalCost = newResult.reduce((acc, x) => { return acc += x.totalCost }, 0)
    //     props.setFilteredTotalCost(totalCost)
    //     console.log(tableRef.current.table.props.data)

    // }

    const handlePageChange = (page) => {
        props.setCurrentPage(page);
    };


    const paginationOptions = {
        sizePerPage: 100,
        onPageChange: handlePageChange,
    };


    const onTableChange = () => {
        console.log('test')
    }


    const tableOptions = {
        stickyHeader: true
    };


    return <div>

        {!props.loading && (
            <BootstrapTable
                keyField="id"
                data={props.products}
                columns={columns}
                cellEdit={cellEditFactory({ mode: 'click', blurToSave: true })}
                //filter={filterFactory()}
                filterPosition="top"
                expandRow={expandRow}
                pagination={paginationFactory(paginationOptions)}
                onTableChange={onTableChange}
                ref={tableRef}
            />
        )}


        <ExportCSVButton {...props.fileredResult}>Export CSV</ExportCSVButton>



    </div>
}

